export function FinalCtaSection() {
  return (
    <section className="relative overflow-hidden" id="cta">
      <img
        alt=""
        aria-hidden="true"
        className="absolute inset-0 h-full w-full object-cover"
        src="/images/lp/cta-bg.png"
      />
      <div aria-hidden="true" className="absolute inset-0 bg-white/40" />
      <div className="relative mx-auto max-w-[900px] px-6 py-32 text-center">
        <h2 className="text-[42px] font-black leading-[1.1] tracking-tight md:text-[60px]">
          <span className="whitespace-nowrap">まずは1通から</span>
          <span className="whitespace-nowrap">変えてみませんか</span>
        </h2>
        <p className="mt-6 text-[15px] leading-relaxed text-ink-600 md:text-[16px]">
          1万円で500通まで、担当者1人でもスカウトを負担なく
        </p>
        <div className="mt-10">
          <a
            className="btn-primary inline-flex h-14 items-center gap-2 rounded-xl px-8 text-[16px] font-bold text-white shadow-pop"
            href="/admin/login"
          >
            <img alt="Chrome" className="h-5 w-5" src="/images/lp/chrome-icon.png" />
            無料トライアル（100人分）で始める
          </a>
        </div>
        <p className="mt-5 text-[12px] text-ink-500">
          ✓ クレジットカード登録で100人分まで全機能を利用できます
        </p>
      </div>
    </section>
  );
}
